import { Home, UtensilsCrossed, ClipboardList } from "lucide-react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { useOrder } from "@/context/OrderContext";

export function BottomNav() {
  const { t } = useLang();
  const { activeOrder } = useOrder();

  const items = [
    { to: "/home", icon: Home, label: t("home"), testId: "nav-home" },
    { to: "/menu", icon: UtensilsCrossed, label: t("menu"), testId: "nav-menu" },
    { to: "/order", icon: ClipboardList, label: t("myOrder"), testId: "nav-order", badge: !!activeOrder },
  ];

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 mx-auto max-w-md border-t border-border bg-background/85 glass pb-safe"
      data-testid="bottom-nav"
    >
      <div className="grid grid-cols-3 px-2 pt-1.5">
        {items.map(({ to, icon: Icon, label, testId, badge }) => (
          <NavLink key={to} to={to} data-testid={testId} className="relative flex flex-col items-center gap-1 py-2">
            {({ isActive }) => (
              <>
                <div className="relative">
                  <Icon
                    className={`h-6 w-6 transition-colors ${isActive ? "text-primary" : "text-muted-foreground"}`}
                    strokeWidth={isActive ? 2.5 : 2}
                  />
                  {badge && (
                    <span className="absolute -end-1.5 -top-1 h-2.5 w-2.5 rounded-full bg-primary ring-2 ring-background" />
                  )}
                </div>
                <span
                  className={`text-[11px] font-semibold transition-colors ${
                    isActive ? "text-primary" : "text-muted-foreground"
                  }`}
                >
                  {label}
                </span>
                {isActive && (
                  <motion.div
                    layoutId="nav-indicator"
                    className="absolute -top-[1px] h-0.5 w-10 rounded-full brand-gradient"
                  />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
